<script>
    import GoogleService from '../../modules/GoogleService';

    export default {
        methods: {
            /**
             * Performs reverse geocoding using Google Maps
             * and returns a promise which resolves to appropriate location name (if any found).
             * @param {Number} lat
             * @param {Number} lng
             * @returns {Promise}
             */
            geocodeLocation({lat, lng}) {
                // eslint-disable-next-line no-unused-vars
                return new Promise((fulfil, reject) => {
                    GoogleService.loadMapsApi().then(({ Geocoder, LatLng, GeocoderStatus }) => {
                        const geocoder = new Geocoder();

                        geocoder.geocode({
                            location: new LatLng(lat, lng),
                        }, (results, status) => {
                            let location = null;

                            if (status === GeocoderStatus.OK && results[0]) {
                                results[0].address_components.forEach((component) => {
                                    component.types.forEach((type) => {
                                        if (!location && ['locality', 'postal_town', 'postal_code'].includes(type)) {
                                            location = component.long_name;
                                        }
                                    });
                                });

                                if (!location) {
                                    location = results[0].formatted_address;
                                }
                            }

                            fulfil({ location });
                        });
                    });
                });
            },
        },
    };
</script>
